import React, { Component } from 'react';

import { setCapitalPage } from 'actions/capital';
import { connect } from 'react-redux';
import * as clevertapCapital from 'clevertap/capital';
import {
  CAPITAL_INTRO_PAGE,
  CAPITAL_ALLOW_PERMISSION_PAGE,
} from 'utils/capitalUtils';
import styles from './PermissionDenied.css';

class PermissionDenied extends Component {
  render() {
    const capitalPermissionDenied =
      'https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/capital/permission-denied.svg';
    return (
      <div className={`row ${styles['body-container']}`}>
        <div className={`row ${styles['row-padding']}`}>
          <div className={`col-sm-5 col-lg-4 ${styles['box-permission']}`}>
            <div className={`${styles['permission-title-section']}`}>
              <div className={`col-xs-5 col-sm-4`}>
                <img
                  src={capitalPermissionDenied}
                  className={`img-responsive ${
                    styles['capital-permission-denied']
                  }`}
                />
              </div>
              <div className={`col-md-8 text-right`}>
                <h3 className={styles['capital-title']}>Permission Denied</h3>
              </div>
            </div>
            <div className={`col-md-12`}>
              <p className={`${styles['justify-text']}`}>
                We need your permission to access your data in Moka to connect
                successfully with Moka Capital
              </p>
            </div>
            <div className={`col-md-12`}>
              <p className={`${styles['justify-text']}`}>
                If you have questions or concerns, feel free to contact us at{' '}
                <a href="mailto:hello@mokapos.com">hello@mokapos.com</a>{' '}
              </p>
            </div>
            <div className={`col-md-12`}>
              <br />
              <a
                className={`btn ${styles['allow-button']}`}
                onClick={this._onClickAllow}
              >
                Allow
              </a>
              <a
                className={`btn ${styles['cancel-button']}`}
                onClick={this._onClickDenied}
              >
                Cancel
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _onClickDenied = () => {
    const { dispatch } = this.props;
    dispatch(setCapitalPage(CAPITAL_INTRO_PAGE));
    clevertapCapital.capitalDeniedCancel();
  };

  _onClickAllow = () => {
    const { dispatch } = this.props;
    dispatch(setCapitalPage(CAPITAL_ALLOW_PERMISSION_PAGE));
    clevertapCapital.capitalClickDeniedAllow();
  };
}

function mapStateToProps(state) {
  const { borrowerProfile } = state.capital;
  return {
    borrowerProfile,
  };
}

export default connect(mapStateToProps)(PermissionDenied);
